"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var module_1 = __importDefault(require("./module"));
var static_1 = require("@angular/upgrade/static");
var storage_service_1 = require("./storage.service");
var cross_domain_storage_service_1 = require("./cross-domain-storage.service");
exports.default = module_1.default;
angular_1.default.module(module_1.default)
    .factory("storageService", static_1.downgradeInjectable(storage_service_1.StorageService))
    .factory("crossDomainStorageService", static_1.downgradeInjectable(cross_domain_storage_service_1.CrossDomainStorageService));
